import { Container } from './styles';


interface ButtonProps {
    children?: any;
    styles?: 'save' | 'new' | 'help' | 'filter' | 'pro' | 'op' | 'activate' | 'reject' | 'secondary';
    type?: 'button' | 'submit';
    Icon?: any;
    onClick?:() => void;
    disabled?: boolean;
}

const ButtonIcon: React.FC<ButtonProps> = ({
    children,
    styles,
    type = 'button',
    Icon = false,
    onClick = () => { },
    disabled = false,
}) => {
    
    return (
        <Container 
            type={type} 
            onClick={disabled ? () => {} : onClick} 
            className={`${styles} ${disabled ? 'disabled' : ''}`}
            disabled={disabled}
        >
            {Icon && (
                <span className="icon">
                    {Icon}
                </span>
            )}
            {
                children && (               
                    <span
                        className="children"
                    >
                        {children}
                    </span>
                )
            }
        </Container>
    );
};

export default ButtonIcon;